import {useMediaQuery} from '@mui/material'
import {useEffect, useState} from 'react'
import {useParams} from 'react-router'
import {FreeMode} from 'swiper'
import {Swiper, SwiperSlide} from 'swiper/react'
import {Swiper as SwiperRef} from 'swiper/types'
import {GetUserSimilar} from 'entities/profile'
import {UserCard} from 'features/userCard'
import {SearchUser} from 'shared/types'
import {ArrowLeft, ArrowRight} from 'shared/ui/icons'
import styles from './styles.module.scss'
import 'swiper/css'

export const SimilarProfiles = () => {
  const [swiperRef, setSwiperRef] = useState<SwiperRef | null>(null)
  const [slide, setSlide] = useState(0)
  const [similar, setSimilar] = useState<SearchUser[]>([])
  const {id} = useParams()
  const [countSlidesPerView, setCountSlidesPerView] = useState(4)
  const is1280p = useMediaQuery(`(max-width: ${styles.is1280p})`)
  const is1140p = useMediaQuery('(max-width: 1140px)')
  const is940p = useMediaQuery('(max-width: 940px)')
  const is600p = useMediaQuery('(max-width: 600px)')

  useEffect(() => {
    if (is600p) return setCountSlidesPerView(2)
    if (is940p) return setCountSlidesPerView(3)
    if (is1140p) return setCountSlidesPerView(4)
    if (is1280p) return setCountSlidesPerView(5)

    return setCountSlidesPerView(4)
  }, [is1280p, is1140p, is940p, is600p])

  useEffect(() => {
    GetUserSimilar(id || '')
      .then(({data: response}) => setSimilar(response.data))
  }, [id])

  const slideTo = (direction: 'left' | 'right') => {
    if (!swiperRef) return

    const maxSlides = similar.length - countSlidesPerView
    let newSlide: number
    if (direction === 'left') {
      if (slide >= countSlidesPerView) { // Если слева есть ещё countSlidesPerView карточек
        newSlide = slide - countSlidesPerView
      } else if (slide > 0) { // Если слева есть ещё карточки но их меньше чем countSlidesPerView
        newSlide = 0
      } else { // Если слева нет карточек
        newSlide = maxSlides
      }
    } else {
      if (maxSlides >= slide + countSlidesPerView) { // Если справа есть ещё countSlidesPerView карточек
        newSlide = slide + countSlidesPerView
      } else if (maxSlides - slide > 0) { // Если справа есть ещё карточки но их меньше чем countSlidesPerView
        newSlide = maxSlides
      } else { // Если справа нет карточек
        newSlide = 0
      }
    }

    setSlide(newSlide)
    swiperRef.slideTo(newSlide, 500)
  }

  if (!similar.length) {
    return <></>
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <div className={styles.text}>Similar profiles</div>

        <div className={styles.buttons}>
          <div className={styles.button} onClick={() => slideTo('left')}>
            <div className={styles.icon}>
              <ArrowLeft />
            </div>
          </div>
          <div className={styles.button} onClick={() => slideTo('right')}>
            <div className={styles.icon}>
              <ArrowRight />
            </div>
          </div>
        </div>
      </div>
      <Swiper
        onSwiper={setSwiperRef}
        slidesPerView={countSlidesPerView}
        spaceBetween={16}
        className={styles.swiper}
        onSlideChange={(swiper) => setSlide(swiper.activeIndex)}
        freeMode={true}
        modules={[FreeMode]}
      >
        {similar.map((item) => <SwiperSlide key={item.id} className={styles.slide}><UserCard trustedUser={item} /></SwiperSlide>)}
      </Swiper>

    </div>
  )
}